export const documentTypes = (state) => state.documentTypes
export const attachOptions = (state) => state.attachOptions

export const invoiceDocumentTypes = (state) => state.invoiceDocumentTypes
export const attachments = (state) => state.attachments
export const attachmentSize = (state) => state.attachmentSize
export const totalAttachments = (state) => state.totalAttachments
export const selectAllField = (state) => state.selectAllField
export const selectedAttachments = (state) => state.selectedAttachments


export const preapprovedInvoiceAttachments = (state) => state.preapprovedInvoiceAttachments
export const preapprovedInvoiceTotalAttachments = (state) => state.preapprovedInvoiceTotalAttachments
export const preapprovedInvoiceSelectAllField = (state) => state.preapprovedInvoiceSelectAllField
export const preapprovedInvoiceSelectedAttachments = (state) => state.preapprovedInvoiceSelectedAttachments


export const prepaymentDocumentTypes = (state) => state.prepaymentDocumentTypes
export const prepaymentAttachments = (state) => state.prepaymentAttachments
export const totalPrepaymentAttachments = (state) => state.totalPrepaymentAttachments
export const prepaymentTotalAttachments = (state) => state.prepaymentTotalAttachments
export const selectAllFieldPrepayment = (state) => state.selectAllFieldPrepayment
export const selectedPrepaymentAttachments = (state) => state.selectedPrepaymentAttachments

export const profileDocumentTypes = (state) => state.profileDocumentTypes
export const profileDocuments = (state) => state.profileDocuments
export const processDocuments = (state) => state.processDocuments
export const processDocumentTypes = (state) => state.processDocumentTypes

export const PODocumentTypes = (state) => state.PODocumentTypes
export const POAttachments = (state) => state.POAttachments
export const totalPOAttachments = (state) => state.totalPOAttachments
export const selectAllFieldPO = (state) => state.selectAllFieldPO
export const selectedPOAttachments = (state) => state.selectedPOAttachments
